import { render, staticRenderFns } from "./UploadQnFile.vue?vue&type=template&id=6483603d"
import script from "./UploadQnFile.vue?vue&type=script&lang=js"
export * from "./UploadQnFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports